export default __webpack_public_path__ + "static/media/Gloves of the Rippling Lake.8a90e8e6.jpg";